module.exports = __webpack_public_path__ + "img/9788949170916.f7e10748.jpg";